export const css = {
	root: '_28MgMYxy',
	loading: 'tF6MtL1K',
	activityHead: '_3di0nDbx',
	feedback: 'ljppnpqF',
	instructions: '_4brr8Htk',
	questionBlock: '_319yRO8d',
	actions: '_2kvvF1WL',
	oneaction: '_2KsFjFSS',
	' _key': 'quiz-widgets/singlestep'
};

export default css;
